import { Namespace, TFunction } from "i18next";

import { ServiceIDs } from "@/utils/constants";

type Rate = {
  /** The monthly product the tile stands for (One, Two, Three). */
  serviceId: ServiceIDs;
  name: string;
  description: string;
  price: string;
  discountPrice: string;
  /** Discounted price as a number, for callers that format it themselves. */
  discountPriceValue: number;
};

const calculateDiscountPrice = (tribeDiscount: number, price: number) => {
  return price - (price * tribeDiscount) / 100;
};

export const getFriendsWithBenefitsRates = ({
  t,
  tribeDiscount,
}: {
  t: TFunction<Namespace, undefined>;
  tribeDiscount: number;
}): Rate[] => [
  {
    serviceId: ServiceIDs.FlatMobileOneMonth,
    name: t("friendsWithBenefits.welcome.flatMobileOne"),
    description: t("friendsWithBenefits.welcome.textFlatMobileOne"),
    price: "CHF 13.00",
    discountPrice: `CHF ${calculateDiscountPrice(tribeDiscount, 13).toFixed(2)}`,
    discountPriceValue: calculateDiscountPrice(tribeDiscount, 13),
  },
  {
    serviceId: ServiceIDs.FlatMobileTwoMonth,
    name: t("friendsWithBenefits.welcome.flatMobileTwo"),
    description: t("friendsWithBenefits.welcome.textFlatMobileTwo"),
    price: "CHF 18.00",
    discountPrice: `CHF ${calculateDiscountPrice(tribeDiscount, 18).toFixed(2)}`,
    discountPriceValue: calculateDiscountPrice(tribeDiscount, 18),
  },
  {
    serviceId: ServiceIDs.FlatMobileThreeMonth,
    name: t("friendsWithBenefits.welcome.flatMobileThree"),
    description: t("friendsWithBenefits.welcome.textFlatMobileThree"),
    price: "CHF 25.00",
    discountPrice: `CHF ${calculateDiscountPrice(tribeDiscount, 25).toFixed(2)}`,
    discountPriceValue: calculateDiscountPrice(tribeDiscount, 25),
  },
];
